<template>
  <footer class="bg-neutral-700 text-white py-12">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
        <div>
          <h4 class="text-xl font-bold mb-4">上海法烙科技有限公司</h4>
          <p class="text-neutral-300 mb-6">
            我们提供专业的法律咨询平台，在数字化浪潮重塑行业格局的当下，我们以 “法律与技术双轮驱动” 为核心定位，为企业提供从合规保障到数字化增长的全链条解决方案。
          </p>
        </div>
        <div>
          <h4 class="text-lg font-bold mb-4">快速链接</h4>
          <ul class="space-y-2">
            <li><a href="#home" class="text-neutral-300 hover:text-white transition-colors duration-200">首页</a></li>
            <li><a href="#features" class="text-neutral-300 hover:text-white transition-colors duration-200">特点</a></li>
            <li><a href="#services" class="text-neutral-300 hover:text-white transition-colors duration-200">服务</a></li>
            <li><a href="#about" class="text-neutral-300 hover:text-white transition-colors duration-200">关于我们</a></li>
            <li><a href="#contact" class="text-neutral-300 hover:text-white transition-colors duration-200">联系我们</a></li>
          </ul>
        </div>
        <div>
          <h4 class="text-lg font-bold mb-4">联系我们</h4>
          <ul class="space-y-2">
            <li class="flex items-start">
              <i class="fa fa-map-marker mt-1 mr-3 text-primary"></i>
              <span class="text-neutral-300">上海市虹口区吴淞路575号907室</span>
            </li>
            <li class="flex items-start">
              <i class="fa fa-envelope mt-1 mr-3 text-primary"></i>
              <span class="text-neutral-300">business@forlawtech.com</span>
            </li>
            <li class="flex items-start">
              <i class="fa fa-clock-o mt-1 mr-3 text-primary"></i>
              <span class="text-neutral-300">周一至周五: 9:00 - 18:00</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="border-t border-neutral-600 pt-8">
        <div class="flex flex-col md:flex-row justify-between items-center">
          <p class="text-neutral-400 text-sm mb-4 md:mb-0">
            Copyright © 上海法烙科技有限公司 版权所有
                备案号：<a href="https://beian.miit.gov.cn" id="BeiAnHao" target="_blank">沪ICP备2025137942号-1</a>
          </p>
          <div class="flex space-x-6">
            <a href="/privacy-policy.html" class="text-neutral-400 hover:text-white text-sm transition-colors duration-200">隐私政策</a>
            <a href="/service-agreement.html" class="text-neutral-400 hover:text-white text-sm transition-colors duration-200">服务协议</a>
<!--            <a href="#" class="text-neutral-400 hover:text-white text-sm transition-colors duration-200">Cookie政策</a>-->
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>
